import { history } from '~/services/history';

/**
 * Checks for presence of a back path and returns it if it exists.
 * Attention! When using make sure, that back path was save, there is a "historyPushWithSaveBackPath" helper for that
 *
 * @see historyPushWithSaveBackPath
 * @param {string} path - path that will return if there is no back path
 * @returns {string}
 */
export const getBackStepPath = (path: string): string => {
  const state = (history.location.state as object) || {};

  return 'backStepPath' in state ? (state.backStepPath as string) : path;
};
